module.exports = __webpack_public_path__ + "front/img/edm-bj-xianshang.ec8a96f0.png";